/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u2m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Steeping green tea, which typically needs 1 to 3 minutes depending on the leaf.`)
};

const es_timer_u2m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dejar en infusión té verde, que normalmente necesita de 1 a 3 minutos según la hoja.`)
};

const de_timer_u2m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grünen Tee ziehen lassen, was je nach Blatt typischerweise 1 bis 3 Minuten dauert.`)
};

const nl_timer_u2m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groene thee laten trekken, wat meestal 1 tot 3 minuten duurt afhankelijk van het blad.`)
};

const fr_timer_u2m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infuser du thé vert, qui nécessite généralement de 1 à 3 minutes selon la feuille.`)
};

const it_timer_u2m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Far riposare il tè verde in infusione, che di solito richiede da 1 a 3 minuti a seconda della foglia.`)
};

const pt_br2_timer_u2m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer a infusão de chá verde, que geralmente precisa de 1 a 3 minutos dependendo da folha.`)
};

const pt_timer_u2m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deixar o chá verde em infusão, o que normalmente precisa de 1 a 3 minutos, consoante a folha.`)
};

const ja_timer_u2m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`茶葉によって1〜3分程度が目安となる緑茶を浸出させる。`)
};

const zh_timer_u2m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`冲泡绿茶，通常需要1到3分钟，具体取决于茶叶种类。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u2m_use2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u2m_use2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u2m_use2", locale)
	if (locale === "en") return en_timer_u2m_use2(inputs)
	if (locale === "es") return es_timer_u2m_use2(inputs)
	if (locale === "de") return de_timer_u2m_use2(inputs)
	if (locale === "nl") return nl_timer_u2m_use2(inputs)
	if (locale === "fr") return fr_timer_u2m_use2(inputs)
	if (locale === "it") return it_timer_u2m_use2(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u2m_use2(inputs)
	if (locale === "pt") return pt_timer_u2m_use2(inputs)
	if (locale === "ja") return ja_timer_u2m_use2(inputs)
	return zh_timer_u2m_use2(inputs)
};